import { Pagination } from '@mui/material'
import { UserTable } from 'components'
import { chunk } from 'lodash'
import { useEffect, useState } from 'react'
import { getUserById, resetPassword, updateUserById } from 'services'
import { PaginatorHolder } from '../styled'
import { ArchivedUsersContainer } from './styled'

interface IArchivedUsersProps {
  content: TableItem[]
}

const Archived = ({ content }: IArchivedUsersProps) => {
  const [currentPage, setCurrentPage] = useState<number>(1)

  const handlePageChange = (_: unknown, page: number) => {
    setCurrentPage(page)
  }

  const userEdit = async (userId?: string | number) => {
    const user = await getUserById(String(userId))
    await updateUserById(String(userId), { ...user, userStatus: 'ACTIVE' })
    await resetPassword(user?.id)
    window.location.reload()
  }
  const [itemsChunk, setItemsChunk] = useState<TableItem[][]>([])
  const [pages, setPages] = useState<number[]>([])

  const configPages = (content: TableItem[]) => {
    const _chunk = chunk(content, 5)
    const _pages = []
    setItemsChunk(_chunk)
    for (const i of _chunk) {
      _pages.push(_chunk.indexOf(i) + 1)
    }
    setPages(_pages)
  }

  useEffect(() => {
    configPages(content)
  }, [content])

  return (
    <ArchivedUsersContainer>
      <UserTable
        keyIndex={4}
        showIndex={false}
        onEdit={userEdit}
        columns={[
          'Name',
          'Phone',
          'Email',
          'InquirySent',
          null as unknown as string
        ]}
        items={itemsChunk[currentPage - 1]}
      />
      <PaginatorHolder>
        {pages.length > 0 && (
          <Pagination count={pages.length} onChange={handlePageChange} />
        )}
      </PaginatorHolder>
    </ArchivedUsersContainer>
  )
}

export default Archived
